export default "__VITE_ASSET__DaV8gyBz__"